import { Component, Input } from "@angular/core";
import { ITreeViewMetadata } from "@tylertech/tyler-api-types";
import { AugmentedModelObject, RepositoryFormData } from "../../../interfaces";
import { TreeViewComponent } from "../treeView/treeView.component";

@Component({
    selector: "metadata-tree",
    templateUrl: "./metadata.tree.tmpl.html",
    imports: [TreeViewComponent]
})
export class MetadataTreeComponent
{
    @Input() viewMetadata: ITreeViewMetadata;
    @Input() entities: any[];
    @Input() datacontroller: RepositoryFormData;
    @Input() model: AugmentedModelObject | AugmentedModelObject[];

    constructor() { }
}
